import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const RocketIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z" />
    <path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z" />
  </svg>
);

const NavIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11l19-9-9 19-2-8-8-2z" />
  </svg>
);

const getActionIcon = (type) => {
  if (!type) return <EditIcon />;
  const t = type.toLowerCase();
  if (t.includes('navigate') || t.includes('go') || t.includes('redirect')) return <NavIcon />;
  if (t.includes('create') || t.includes('add') || t.includes('launch')) return <RocketIcon />;
  return <EditIcon />;
};

const ActionPreview = ({ action, onExecute, onCancel }) => {
  if (!action) {
    return null;
  }

  const { type, data, preview, label } = action;
  const actionIcon = getActionIcon(type);
  const title = label || data?.field || type;

  return (
    <div className="ai-assistant-sidebar__action-preview">
      <div className="ai-assistant-sidebar__action-preview-header">
        {actionIcon}
        <span>Update {title}</span>
      </div>

      <div className="ai-assistant-sidebar__action-preview-body">
        {preview?.after && (
          <div className="ai-assistant-sidebar__preview-section">
            <label>New value</label>
            <div className="ai-assistant-sidebar__preview-content ai-assistant-sidebar__preview-content--highlight">
              {preview.after}
            </div>
          </div>
        )}

        {!preview?.after && (
          <div className="ai-assistant-sidebar__preview-description">
            {data?.description || `Apply ${title}`}
          </div>
        )}
      </div>

      <div className="ai-assistant-sidebar__action-preview-footer">
        <button
          className="ai-assistant-sidebar__action-btn ai-assistant-sidebar__action-btn--cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="ai-assistant-sidebar__action-btn ai-assistant-sidebar__action-btn--primary"
          onClick={onExecute}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

ActionPreview.propTypes = {
  action: PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    preview: PropTypes.shape({
      before: PropTypes.string,
      after: PropTypes.string
    }),
    label: PropTypes.string
  }),
  onExecute: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ActionPreview;
